// Client-side mirror of config/locales/plurals.rb for the languages that need
// more than one/other (sk, cs, ro, uk) or split one/other differently from
// English (fr: 0 is singular). Counts here are item counts — non-negative
// integers — so the fraction arm of the Ruby rules is not reproduced.
export function pluralCategory(lang, count) {
  const code = (lang || "en").toLowerCase()
  const n = Math.abs(Math.trunc(count))

  if (code.startsWith("sk") || code.startsWith("cs")) {
    if (n === 1) return "one"
    if (n >= 2 && n <= 4) return "few"
    return "other"
  }

  if (code.startsWith("uk")) {
    const mod10 = n % 10
    const mod100 = n % 100
    if (mod10 === 1 && mod100 !== 11) return "one"
    if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return "few"
    return "many"
  }

  if (code.startsWith("ro")) {
    const mod100 = n % 100
    if (n === 0) return "zero"
    if (n === 1) return "one"
    if (mod100 >= 1 && mod100 <= 19) return "few"
    return "other"
  }

  // French: `one` for 0 and 1. CLDR's `many` (exact millions) is deliberately
  // not selected, matching the Ruby rule, so no table needs a third form.
  if (code.startsWith("fr")) return n < 2 ? "one" : "other"

  return n === 1 ? "one" : "other"
}

// Picks the text for `count` out of a plural table `{ one, few, many, other }`
// (the JSON a view emits with `plural_texts_json`). A table written for a
// language with fewer categories (sk has no `many`) degrades to `other`.
export function pluralText(texts, lang, count) {
  if (!texts) return ""
  return texts[pluralCategory(lang, count)] ?? texts.other ?? ""
}
